<template>
  <div class="curriculum-learning">
    <!-- 顶部标题区域 -->
    <div class="header-section">
      <div class="header-left">
        <div class="course-title">
          <span class="title-text">{{
            courseName || "本科段-大学语文 英语 高数 计算机-辅导课程"
          }}</span>
        </div>
        <div class="header-left-side">
          <div class="validity-period">
            <span class="validity-label">有效期：</span>
            <span class="validity-value">{{
              calculateTheValidityPeriod(validityTime)
            }}</span>
          </div>
          <div class="operation-btn" @click="goOperation">
            <span class="operation-icon">
              <img style="width: 10px;height: 10px;" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/99.png" alt="">
            </span>
            <span>操作教程</span>
          </div>
        </div>
      </div>
      <div class="header-right">
        <div class="view-purchased-btn" @click="viewPurchased">
          查看已购班型
          <img style="width: 13px;height: 11px;margin-left: 5px;" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/109.png" alt="">
        </div>
      </div>
    </div>

    <!-- 功能模块卡片区域 -->
    <div v-if="productLine == 3" class="year_box">
      <!-- 专属教辅 -->
      <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/103.png" @click="openTextBook" />
      <!-- 专属资料 -->
      <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/105.png" @click="openMaterial" />
      <!-- 专属题库 -->
      <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/106.png" @click="openQuestionBank" />
      <!-- 专属考场 -->
      <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/110.png" @click="openRoom" /> 
      <!-- 专属教服 -->
      <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/108.png" @click="openEducate" />
    </div>

    <!-- 主体内容区域 -->
    <CoursePackageContent v-if="types == 0" :courseList="courseList" :selectedCourseId="selectedCourseId"
      :currentChapters="currentChapters" :classesId="classesId" :type="type" :productLine="productLine"
      :yearList="yearList" :selectedYear="selectedYear" :isPastCourseMode="isPastCourseMode" :pastCourses="pastCourses"
      :showAllCourses="showAllCourses" :userInfo="userInfo" :isFreeze="isFreeze" :isOutsourcing="isOutsourcing"
      @select-course="selectCourse" @toggle-show-all-courses="showMoreCourses"
      @toggle-past-course-mode="togglePastCourseMode" @select-year="selectYear" @toggle-chapter="toggleChapter"
      @open-course-material="openCourseMaterial" @open-course-test="openCourseTest" @go-data="goData"
      @check-task="cgeckTask" @check="check" @check-xbk="checkxbk" @checks="checks" />
    <CourseDetail v-else 
      :courseName="courseName" 
      :courseId="selectedCourseId"
      :type="type"
      :types="types"
      :studentId="userInfo?.id"
      :courseDocFlag="selectedCourseDocFlag"
      :courseTestFlag="selectedCourseTestFlag"
      @course-material="() => dialogVisible = true" 
      @course-test="() => dialogVisibles = true"
      @lesson-material="(lesson) => openCourseMaterial(lesson)"
      @lesson-test="(lesson) => openCourseTest(lesson)"
      @study-lesson="(lesson) => checks(lesson, {}, 0)" />
    <!-- 弹窗组件 -->
    <!-- 专属教服弹窗 -->
    <educate-dialog ref="educateDialog" :direction="direction" :educate-visible="educateVisible"
      @educateClose="educateClose" />
    <!-- 专属教材弹窗 -->
    <text-book-dialog ref="textBookDialog" :direction="direction" :book-visible="bookVisible" :is-purchase="true"
      @bookClose="bookClose" />
    <!-- 专属考场弹窗 -->
    <el-dialog title="专属考场" class="new_bac" :visible.sync="roomVisible">
      <room-dialog v-if="roomVisible" ref="roomDialog" :direction="direction" :classes-id="classesId"
        :is-purchase="true" />
    </el-dialog>
    <!-- 专属资料 -->
    <material ref="material" :material-visible="materialVisible" :classes-id="classesId" :direction="direction"
      @materialClose="materialClose" />
    <!-- 专属题库 -->
    <el-dialog title="专属题库" class="new_bac" :visible.sync="questionBankVisible">
      <classes-question :classes-id="classesId" :is-purchase="true" />
    </el-dialog>

    <!-- 已购班型弹框 -->
    <CourseSelector :visible.sync="purchasedDialogVisible" :purchased-list="purchasedList"
      @select-course="selectPurchasedCourse" />
    <!-- 课程资料弹窗 -->
    <el-dialog class="new_bac" title="课程资料" :visible.sync="dialogVisible">
      <CourseData :newproductLine="newproductLine" :newkcId="newkcId" v-if="dialogVisible" :id="kid" :type="1"
        :is-purchase="true" />
    </el-dialog>
    <!-- 课程测试弹窗 -->
    <el-dialog class="new_bac" title="课程测试" :visible.sync="dialogVisibles">
      <courseTask :newproductLine="newproductLine" :newkcId="newkcId" v-if="dialogVisibles" :id="kid" :type="1"
        :is-purchase="true" />
    </el-dialog>
    <!-- 是否可以观看弹窗 -->
    <div v-if="showLookDetail" class="lookBg">
      <div class="ifLook">
        <div class="prompt">提示</div>
        <div class="contents">
          您当前正在<span>{{ lookDeatil ? lookDeatil.terminal : '' }}</span>观看<span>{{ lookDeatil ? lookDeatil.chapterName :
            ''
          }}</span>，请关闭后再行观看其他章节。
        </div>
        <div class="button" @click="closeLook">关闭</div>
      </div>
    </div>

    <!-- 操作教程全屏蒙版 -->
    <div v-if="showOperationMask" class="operation-mask" @click="closeOperationMask">
      <div class="operation-mask-content">
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/102.png" alt="操作教程" class="operation-image" />
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from "@/api/cookies";
import { getClass } from "@/api/home.js";
import {
  selectRateByClassIdYearStudentIdPC,
  getClassCourseListById,
  selectChapterRateBykeIdStudentIdGroupId,
  selectChapterRateByStatusAndkeIdStudentId,
} from "@/api/mykecheng";
import { Know, courseCheckPlay } from "@/api/know";
import { AnswerClient } from "@/api/task/answerClient";
import Vue from "vue";
import roomDialog from "@/views/class/dialog/roomDialog.vue";
import educateDialog from "@/views/class/dialog/educateDialog.vue";
import textBookDialog from "@/views/class/dialog/textBookDialog.vue";
import material from "@/views/class/dialog/materialDialog.vue";
import classesQuestion from "@/components/Know/classCom/classes-question.vue";
import CourseData from "@/components/Know/course/courseData.vue";
import courseTask from "@/components/Know/course/courseTask.vue";
import CoursePackageContent from "./components/CoursePackageContent.vue";
import CourseSelector from "./components/CourseSelector.vue";
import CourseDetail from "./components/CourseDetail.vue";

export default {
  name: "CurriculumLearning",
  components: {
    roomDialog,
    educateDialog,
    textBookDialog,
    material,
    classesQuestion,
    CourseData,
    courseTask,
    CoursePackageContent,
    CourseSelector,
    CourseDetail,
  },
  data() {
    const answerClient = new AnswerClient();
    return {
      userInfo: null,
      courseName: "",
      validityTime: null,
      courseList: [],
      selectedCourseId: null,
      currentChapters: [],
      classesId: null,
      kcbClassId: null,
      type: null,
      productLine: null,
      detalilsList: {},
      educateVisible: false,
      bookVisible: false,
      roomVisible: false,
      materialVisible: false,
      questionBankVisible: false,
      direction: "",
      courseType: ["直播课", "录播课", "直播课", "直播课", "面授课"],
      showAllCourses: false,
      purchasedDialogVisible: false,
      purchasedList: [],
      know: new Know(),
      answerClient,
      gchapterVOList: [],
      subChapterLoading: false,
      kid: null,
      dialogVisible: false,
      dialogVisibles: false,
      newproductLine: "1",
      newkcId: "",
      lookDeatil: null,
      showLookDetail: false,
      isFreeze: 0,
      isOutsourcing: 0,
      ifDialog: false,
      dialogList: null,
      addTime: null,
      yearList: [],
      selectedYear: null,
      isPastCourseMode: false,
      pastCourses: [],
      showOperationMask: false,
      types: 0,
      selectedCourseDocFlag: 0,
      selectedCourseTestFlag: 0
    };
  },

  computed: {
    displayCourseList() {
      if (this.showAllCourses) {
        return this.courseList;
      }
      return this.courseList.slice(0, 6);
    },
    shouldShowMoreButton() {
      return this.courseList.length > 6;
    },
  },

  created() {
    this.userInfo = getInfo()
    this.initData()
    this.checkAndShowOperationMask()
  },
  beforeRouteLeave(to, from, next) {
    this.closeAllDialogs()
    next()
  },
  beforeDestroy() {
    this.closeAllDialogs()
  },
  methods: {
    closeAllDialogs() {
      this.educateVisible = false
      this.bookVisible = false
      this.roomVisible = false
      this.materialVisible = false
      this.questionBankVisible = false
      this.purchasedDialogVisible = false
    },
    async togglePastCourseMode() {
      this.isPastCourseMode = !this.isPastCourseMode;
      if (this.isPastCourseMode) {
        await this.getYearList();
      }
    },
    async getYearList() {
      try {
        const params = {
          type: 2,
          classesId: this.type == 1 ? this.classesId : this.kcbClassId,
          userid: this.userInfo.id,
          kId: this.selectedCourseId,
          payTime: this.addTime
        };
        const res = await this.know.getClassesCourseTypeYearListNew(params);
        if (res.code == 0 && res.data && res.data.length > 0) {
          this.yearList = [];
          this.yearList = [...new Set(res.data)];
          if (this.yearList.length > 0) {
            this.selectedYear = this.yearList[0];
            await this.getPastCourseList();
          }
        }
      } catch (error) {
        console.error("获取年份列表失败", error);
      }
    },
    async selectYear(year) {
      this.selectedYear = year;
      await this.getPastCourseList();
    },
    async getPastCourseList() {
      try {
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: '',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        const res = await this.know.pastCourseListNew(
          this.type == 1 ? this.classesId : this.kcbClassId,
          this.userInfo.id,
          this.selectedYear,
          this.selectedCourseId,
          undefined
        );
        if (res.code == 0 && res.data) {
          this.pastCourses = res.data.map((item, index) => {
            // 处理子章节，将所有子章节的 isshow 设置为 false
            let chapterNewVOS = item.chapterNewVOS || [];
            chapterNewVOS = chapterNewVOS.map((subItem) => ({
              ...subItem,
              isshow: false,
            }));
            return {
              ...item,
              chapterNewVOS,
              expanded: false
            };
          });
          // 默认展开第一个课程并加载数据
          if (this.pastCourses.length > 0) {
            await this.toggleChapter(this.pastCourses[0]);
          }
        }
        loading.close();
      } catch (error) {
        console.error("获取往期课程列表失败", error);
      }
    },
    async initData() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      const success = await this.getClassCourseData();

      if (success) {
        this.getClassDetail();
        await this.getCourseList();
      } else {
        this.initMockData();
      }

      loading.close();
    },

    async getClassCourseData() {
      try {
        const res = await getClassCourseListById(
          this.userInfo.id,
          1,
          100,
          1,
        );
        if (res.code != 500 && res.rows && res.rows.length > 0) {
          // 找到第一个非已过期的班型
          const validCourse = res.rows.find(course => {
            if (!course.validityTime) return false;
            const currentTime = new Date();
            const timeStr = course.validityTime.toString().replace(/-/g, "/");
            const targetTime = new Date(timeStr);
            return targetTime.getTime() - currentTime.getTime() >= 0;
          });
          
          // 如果没有找到未过期的，就用第一个
          const selectedCourse = validCourse || res.rows[0];
          
          this.courseName = selectedCourse.name;
          this.validityTime = selectedCourse.validityTime;
          this.classesId = selectedCourse.coursesId;
          this.kcbClassId = selectedCourse.kcbClassId;
          this.type = selectedCourse.type;
          this.productLine = selectedCourse.productLine;
          this.addTime = selectedCourse.addTime;
          return true;
        }
        return false;
      } catch (error) {
        console.error("获取课程数据失败", error);
        return false;
      }
    },

    async getClassDetail() {
      try {
        const res = await getClass(this.classesId);
        if (res.code == 200) {
          this.detalilsList = JSON.parse(JSON.stringify(res.data.BX));
        }
      } catch (error) {
        console.error("获取课程详情失败", error);
      }
    },

    async getCourseList() {
      try {
        const data = {
          classesId: this.classesId,
          packageId: this.type == 16 ? this.classesId : null,
          studentId: this.userInfo.id,
          type: this.type,
        };
        const res = await selectRateByClassIdYearStudentIdPC(data);
        if (res.code == 0) {
          this.courseList = res.msg.map((item) => ({
            id: item.kcId,
            name: item.kcName,
            types: item.courseTypes
              ? item.courseTypes.split(",")
              : ["1", "2"],
            courseDocFlag: item.courseDocFlag || 0,
            courseTestFlag: item.courseTestFlag || 0,
          }));

          if (this.courseList.length > 0) {
            this.selectCourse(this.courseList[0]);
          }
        }
      } catch (error) {
        console.error("获取课程列表失败", error);
        this.initMockData();
      }
    },

    initMockData() {
      this.courseList = [];
      this.currentChapters = [];
    },

    async selectCourse(course) {
      this.selectedCourseId = course.id;
      this.selectedCourseDocFlag = course.courseDocFlag || 0;
      this.selectedCourseTestFlag = course.courseTestFlag || 0;
      this.isPastCourseMode = false;
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        const res = await this.know.classesNewCourseList(
          this.type == 1 ? this.classesId : this.kcbClassId,
          this.userInfo.id,
          undefined,
          undefined,
          course.id,
          undefined
        );
        if (res.code == 0 && res.data) {
          this.currentChapters = res.data.map((item, index) => {
            let chapterNewVOS = item.chapterNewVOS || [];
            chapterNewVOS = chapterNewVOS.map((subItem) => ({
              ...subItem,
              isshow: false,
            }));

            return {
              ...item,
              id: item.id || index,
              name: item.title || item.name,
              type: item.type == 1 ? "直播课" : "录播课",
              chapterCount: chapterNewVOS.length || (item.sections ? item.sections.length : 0),
              studyRate: item.liveClass || item.recordStudy || 0,
              expanded: false,
              sections: [],
              chapterNewVOS: chapterNewVOS,
              
            };
          });
          // 默认展开第一个章节并加载数据
          if (this.currentChapters.length > 0) {
            await this.toggleChapter(this.currentChapters[0]);
          }
        } else {
          this.initMockData();
        }
      } catch (error) {
        console.error("获取章节数据失败", error);
        this.initMockData();
      } finally {
        loading.close();
      }
    },

    async toggleChapter(chapter) {
      const list = this.isPastCourseMode ? this.pastCourses : this.currentChapters;

      list.forEach(c => {
        if (c.id !== chapter.id) {
          c.expanded = false
        }
      })
      chapter.expanded = !chapter.expanded

      if (!chapter.expanded) {
        return
      }

      const chapterType = typeof chapter.type === 'number'
        ? (chapter.type === 1 ? '直播课' : '录播课')
        : chapter.type;

      const hasData = chapterType === '直播课'
        ? (chapter.sections && chapter.sections.length > 0)
        : (chapter.chapterNewVOS && chapter.chapterNewVOS.length > 0)
      
      if (hasData) {
        return
      }

      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        const data = {
          keId: chapter.id,
          courseType: chapterType === '直播课' ? 1 : 2,
          studentId: this.userInfo.id
        }
        const res = await selectChapterRateByStatusAndkeIdStudentId(data);
        console.log(res, 'res')

        if (res.code == 0) {
          if (chapterType === '直播课') {
            this.$set(chapter, 'sections', res.msg)
          } else {
            const chapterNewVOS = res.msg.map((subItem) => ({
              ...subItem,
              isshow: false,
            }))
            this.$set(chapter, 'chapterNewVOS', chapterNewVOS)
          }
        }
      } catch (error) {
        console.error("获取章节数据失败", error);
      } finally {
        loading.close();
      }
    },

    openEducate() {
      this.educateVisible = true;
      this.$refs.educateDialog.init(
        this.detalilsList.jfServer,
        this.detalilsList,
      );
    },
    educateClose() {
      this.educateVisible = false;
    },
    openTextBook() {
      this.bookVisible = true;
      this.$refs.textBookDialog.init(
        this.classesId,
        true,
        this.detalilsList.tiitle,
      );
    },
    bookClose() {
      this.bookVisible = false;
    },
    openRoom() {
      this.roomVisible = true;
    },
    openMaterial() {
      this.materialVisible = true;
      this.$refs["material"].init(this.classesId, true);
    },
    materialClose() {
      this.materialVisible = false;
    },
    openQuestionBank() {
      this.$router.push({
        path: "/partnerPage/indexParent",
        query: { bxId: this.classesId, type: this.type },
      });
    },

    openCourseMaterial(chapter) {
      this.kczl(chapter);
    },

    openCourseTest(chapter) {
      this.kccs(chapter);
    },

    kczl(item) {
      this.kid = item.id;
      this.newproductLine = item.productLine || "1";
      this.newkcId = item.kid;
      this.dialogVisible = true;
    },

    kccs(item) {
      this.kid = item.id;
      this.newproductLine = item.productLine || "1";
      this.newkcId = item.kid;
      this.dialogVisibles = true;
    },

    goData(item, type, items) {
      const userInfo = getInfo();
      if (!userInfo) {
        Vue.prototype.goLoginView(false);
        return;
      }
      if (type == 9) {
        window.open(
          `/data/dataPackageDetailXbk?classesId=${this.classesId}&courseId=${items.id}&sectionId=${item.id}`,
          "_blank"
        );
      } else {
        window.open(
          `/data/dataPackageDetails?courId=${items.id}&classesId=${this.classesId}&courseType=${items.type}&type=2&docType=${type}&ChatId=${item.id}&groupId=${item.groupId ? item.groupId : undefined}`,
          "_blank"
        );
      }
    },

    cgeckTask(item) {
      const title = item.testList[0].sjName;
      const sId = item.testList[0].cContactid;
      this.answerClient.selectPaperSubjectList(sId).then((res) => {
        if (res.code == 0) {
          Vue.prototype.goExams(title, sId, 2, 1, true, res.data.paper.seeNum);
        }
      });
    },
    check(item, group) {
      const userInfo = getInfo()
      if (!userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }

      if (this.isFreeze == 1) {
        this.$message.error('课程已冻结')
        return
      }
      if (item.isLive == 0) {
        this.$message.error('课程还未到开播时间')
        return
      }
      if (item.isLive == 2) {
        this.$message.error('课程直播结束')
        return
      }

      const sub = {
        id: item.id,
        classId: this.classesId,
        coursePackageId: this.classesId,
        startTime: item.startTime,
        chapterName: item.name,
        typekc: this.type,
        classProductLine: group.productLine
      }
      for (const key in sub) {
        if (!sub[key] && sub[key] !== 0) {
          delete sub[key]
        }
      }
      const data = Vue.prototype.export(sub)
      courseCheckPlay({
        courseType: 1,
        userId: this.userInfo.id,
        chapterId: item.id,
        source: 1
      }).then((res) => {
        if (res.code == 0) {
          const routeUrl = this.$router.resolve({
            path: `/livebofang?${data}`
          })
          window.open(routeUrl.href, '_blank')
        } else {
          this.lookDeatil = res.msg
          this.showLookDetail = true
        }
      })
    },
    checkxbk(item, group) {
      const userInfo = getInfo()
      if (!userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }

      if (this.isFreeze == 1) {
        this.$message.error('课程已冻结')
        return
      }
      if (item.liveStatus == 0) {
        this.$message.error('课程还未到开播时间')
        return
      }
      if (item.liveStatus == 2) {
        this.$message.error('课程直播结束')
        return
      }

      const sub = {
        courseId: item.courseId,
        classesId: this.classesId,
        sectionId: item.id,
        liveStatus: item.liveStatus
      }
      for (const key in sub) {
        if (!sub[key] && sub[key] !== 0) {
          delete sub[key]
        }
      }
      const data = Vue.prototype.export(sub)
      courseCheckPlay({
        courseType: 1,
        userId: this.userInfo.id,
        chapterId: item.id,
        source: 1
      }).then((res) => {
        if (res.code == 0) {
          const routeUrl = this.$router.resolve({
            path: `/livebofangxbk?${data}`
          })
          window.open(routeUrl.href, '_blank')
        } else {
          this.lookDeatil = res.msg
          this.showLookDetail = true
        }
      })
    },
    checks(item, group, index) {
      const userInfo = getInfo()
      if (!userInfo) {
        Vue.prototype.goLoginView(false)
        return
      }
      if (this.isFreeze == 1) {
        this.$message.error('课程已冻结')
        return
      }

      if (this.isOutsourcing == 1) {
        this.ifDialog = true
        this.dialogList = item
      } else {
        const sub = {
          id: item.id,
          uservideoConfig: item.videoConfig,
          courseId: group.id,
          classId: this.classesId,
          groupId: this.kid,
          typebs: 2,
          chapterName: item.name,
          typekc: this.type,
          classProductLine: group.productLine
        }
        const data = Vue.prototype.export(sub)
        courseCheckPlay({
          courseType: 2,
          userId: this.userInfo.id,
          chapterId: item.id,
          source: 1
        }).then((res) => {
          if (res.code == 0) {
            this.$router.push(`/dianbofang?${data}&openIndex=${index}`)
          } else {
            this.lookDeatil = res.msg
            this.showLookDetail = true
          }
        })
      }
    },
    closeLook() {
      this.showLookDetail = false
    },

    goOperation() {
      this.showOperationMask = true;
    },
    closeOperationMask() {
      this.showOperationMask = false;
      // 保存用户已查看的状态
      localStorage.setItem('hasSeenOperationMask', 'true');
    },
    checkAndShowOperationMask() {
      // 检查是否是首次查看
      const hasSeen = localStorage.getItem('hasSeenOperationMask');
      if (!hasSeen) {
        this.showOperationMask = true;
      }
    },

    viewPurchased() {
      this.getPurchasedList();
    },

    async getPurchasedList() {
      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        const res = await getClassCourseListById(
          this.userInfo.id,
          3,
          100,
          1,
        );
        if (res.code != 500 && res.rows) {
          this.purchasedList = res.rows;
        } else {
          this.purchasedList = [];
        }
        this.purchasedDialogVisible = true;
      } catch (error) {
        console.error("获取已购班型失败", error);
        this.purchasedList = [];
        this.purchasedDialogVisible = true;
      } finally {
        loading.close();
      }
    },

    async selectPurchasedCourse(item) {
      console.log(item, 'item');
      this.courseName = item.name;
      this.validityTime = item.validityTime;
      this.classesId = item.coursesId;
      this.kcbClassId = item.kcbClassId;
      this.type = item.type;
      this.productLine = item.productLine;
      this.addTime = item.addTime;
      this.types = item.types;

      this.purchasedDialogVisible = false;

      const loading = this.$loading({
        lock: true,
        text: '加载中',
        spinner: '',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      try {
        this.getClassDetail();
        await this.getCourseList();
      } finally {
        loading.close();
      }
    },

    showMoreCourses() {
      this.showAllCourses = !this.showAllCourses;
    },

    calculateTheValidityPeriod(time) {
      if (!time) return "已过期";
      const currentTime = new Date();
      time = time ? time.toString().replace(/-/g, "/") : time;
      const targetTime = new Date(time);
      const difference = targetTime.getTime() - currentTime.getTime();
      if (difference < 0) {
        return "已过期";
      }
      const year = Math.floor(difference / 1000 / 60 / 60 / 24 / 365);
      const days =
        Math.floor(difference / 1000 / 60 / 60 / 24) - Math.floor(year * 365);
      return year + "年" + days + "天";
    },

 

    async ifshow(row, i, chapter) {
      this.gchapterVOList = [];
      if (i == 1) {
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: '',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
          this.subChapterLoading = true;
          const res = await selectChapterRateBykeIdStudentIdGroupId({
            keId: chapter.id,
            groupId: row.id,
            studentId: this.userInfo.id
          });

          chapter.chapterNewVOS.forEach((e) => {
            e.isshow = false;
          });

          if (res.code == 0 && res.msg && res.msg.length > 0) {
            this.gchapterVOList = res.msg;
          } else {
            this.gchapterVOList = [
              { id: row.id + '-1', name: row.name + ' 第1课时', studyRate: 80 },
              { id: row.id + '-2', name: row.name + ' 第2课时', studyRate: 50 },
            ];
          }
          row.isshow = true;
          this.subChapterLoading = false;
          this.$forceUpdate();
        } catch (error) {
          console.error("获取子章节数据失败", error);
          chapter.chapterNewVOS.forEach((e) => {
            e.isshow = false;
          });
          this.gchapterVOList = [
            { id: row.id + '-1', name: row.name + ' 第1课时', studyRate: 80 },
            { id: row.id + '-2', name: row.name + ' 第2课时', studyRate: 50 },
          ];
          row.isshow = true;
          this.subChapterLoading = false;
          this.$forceUpdate();
        } finally {
          loading.close();
        }
      } else {
        row.isshow = false;
        this.$forceUpdate();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.curriculum-learning {
  width: 100%;
  min-height: 100vh;
  padding: 20px 0;

  .header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
    padding: 20px 24px;
    border-radius: 8px;
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    background: url(https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/96.png);

    .header-left {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 16px;

      .course-title {
        .title-text {
          font-size: 20px;
          font-weight: 600;
          color: #333;
        }
      }

      .header-left-side {
        display: flex;
        align-items: center;
        gap: 16px;

        .validity-period {
          display: flex;
          align-items: center;
          padding: 4px 6px;
          background: #FFE2E6;
          border-radius: 4px;

          .validity-label {
            color: #DD6572;
            font-size: 12px;
          }

          .validity-value {
            color: #DD6572;
            font-size: 12px;
            font-weight: 500;
          }
        }

        .operation-btn {
          display: flex;
          align-items: center;
          gap: 4px;
          color: #096DD1;
          font-size: 12px;
          cursor: pointer;
          transition: color 0.3s;

          // &:hover {
          //   color: #4a6af0;
          // }

          // .operation-icon {
          //   font-size: 16px;
          // }
        }
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      padding-top: 4px;

      .view-purchased-btn {
        padding: 10px 20px;
        background: #4a6af0;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        transition: background 0.3s;
        display: flex;
        align-items: center;
        

        &:hover {
          background: #3a5ae0;
        }
      }
    }
  }

  .year_box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;

    img {
      width: 190px;
      height: 68px;
      cursor: pointer;
      transition: transform 0.3s;

      &:hover {
        transform: translateY(-4px);
      }
    }
  }
}

.lookBg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;

  .ifLook {
    width: 500px;
    background-color: #fff;
    padding: 10px;
    border-radius: 10px;
    border: 1px solid #ccc;

    .prompt {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 20px;
    }

    .contents {
      width: 380px;
      margin: 20px auto;

      >span {
        color: red;
      }
    }

    .button {
      width: 120px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      border-radius: 10px;
      border: 1px solid #ccc;
      cursor: pointer;
      background: #4a6af0;
      color: #fff;
    }
  }
}

.operation-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  cursor: pointer;

  .operation-mask-content {
    position: relative;
    max-width: 90%;
    max-height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: default;

    .operation-image {
      max-width: 100%;
      max-height: 90vh;
      object-fit: contain;
      border-radius: 8px;
    }
  }
}
</style>
